import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './orte.list-view.html',
    styleUrls: ['./orte.list-view.scss']
})
export class OrteListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
